"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var abc = _interopRequireWildcard(require("@/api/jhyc/juyc"));
var _logistics = require("@/api/logistics");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var defaultObj = {
  id: null,
  businessLicense: '',
  storeName: '',
  phone: '',
  startTime: '',
  endTime: '',
  map: '',
  region: [],
  regionName: '',
  address: '',
  sliderImages: []
};
var _default = exports.default = {
  name: 'abcStoreAdd',
  props: ['editData', 'isCreate'],
  components: {},
  data: function data() {
    return {
      isDisabled: false,
      ruleForm: Object.assign({}, defaultObj),
      groupData: [],
      labelData: '',
      rules: {},
      labelLists: [],
      regSelect: [],
      regProps: {
        value: 'regionName',
        label: 'regionName',
        children: 'child',
        expandTrigger: 'hover',
        checkStrictly: true,
        emitPath: true
      }
    };
  },
  mounted: function mounted() {
    this.cityListTreeHandler();
  },
  created: function created() {
    this.ruleForm.sliderImages = [];
    this.init();
  },
  methods: {
    // // 点击商品图
    // modalPicTap(tit, num, i, status) {
    //   const _this = this;
    //   if (_this.isDisabled) return;
    //   this.$modalUpload(
    //     function (img) {
    //       if (tit === '1' && !num) {
    //         _this.ruleForm.image = img[0].sattDir;
    //         _this.OneattrValue[0].image = img[0].sattDir;
    //       }
    //       if (tit === '2' && !num) {
    //         if (img.length > 10) return this.$message.warning('最多选择10张图片！');
    //         if (img.length + _this.ruleForm.sliderImages.length > 10)
    //           return this.$message.warning('最多选择10张图片！');
    //         img.map((item) => {
    //           _this.ruleForm.sliderImages.push(item.sattDir);
    //         });
    //       }
    //       if (tit === '1' && num === 'dan') {
    //         _this.OneattrValue[0].image = img[0].sattDir;
    //       }
    //       if (tit === '1' && num === 'duo') {
    //         _this.ManyAttrValue[i].image = img[0].sattDir;
    //       }
    //       if (tit === '1' && num === 'pi') {
    //         _this.oneFormBatch[0].image = img[0].sattDir;
    //       }
    //     },
    //     tit,
    //     'content',
    //   );
    // },
    handleRemove: function handleRemove(i) {
      this.ruleForm.sliderImages.splice(i, 1);
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      if (!this.isDisabled) this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      if (!this.isDisabled) this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      if (!this.isDisabled) e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item) {
      if (!this.isDisabled) {
        e.dataTransfer.effectAllowed = 'move';
        if (item === this.dragging) {
          return;
        }
        var newItems = _toConsumableArray(this.ruleForm.sliderImages);
        var src = newItems.indexOf(this.dragging);
        var dst = newItems.indexOf(item);
        newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
        this.ruleForm.sliderImages = newItems;
      }
    },
    init: function init() {
      if (this.isCreate === 1) {
        for (var key in this.editData) {
          this.ruleForm[key] = this.editData[key];
        }
        var time = this.editData.openTime.split('-');
        this.ruleForm['startTime'] = time[0];
        this.ruleForm['endTime'] = time[1];
        this.ruleForm['map'] = this.editData.lng + ',' + this.editData.lat;
        this.ruleForm['region'].push(this.editData.city);
        this.ruleForm['region'].push(this.editData.district);
        this.ruleForm['sliderImages'] = this.editData.imageList ? this.editData.imageList.split(',') : [];
        console.log(this.ruleForm);
      }
    },
    handleChange: function handleChange(value) {
      console.log(value);
      if (value) {
        var obj = '';
        value.forEach(function (item) {
          console.log(item);
          obj += item;
        });
        this.ruleForm.regionName = obj;
      }
    },
    getMapGeo: function getMapGeo() {
      var _this = this;
      if (!this.ruleForm.regionName || !this.ruleForm.address) {
        this.$message.warning('请填写详情地址');
        return;
      }
      abc.abcMapGeoApi({
        address: this.ruleForm.regionName + this.ruleForm.address
      }).then(function (res) {
        console.log(res);
        _this.ruleForm.map = res.geocodes ? res.geocodes[0].location : '未知';
      });
    },
    cityListTreeHandler: function cityListTreeHandler() {
      var _this2 = this;
      (0, _logistics.cityListTree)().then(function (res) {
        _this2.regSelect = res;
      });
    },
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this3 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          if (_this3.isCreate === 0) {
            abc.abcStoreByAdd(_this3.ruleForm).then(/*#__PURE__*/function () {
              var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _this3.$message.success('增加成功');
                      _this3.resetForm('ruleForm');
                      _this3.$parent.$parent.visible = false;
                      _this3.$parent.$parent.getList();
                    case 1:
                      return _context.a(2);
                  }
                }, _callee);
              }));
              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }());
          }
          if (_this3.isCreate === 1) {
            abc.abcStoreByEdit(_this3.ruleForm).then(/*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this3.$message.success('编辑成功');
                      _this3.resetForm('ruleForm');
                      _this3.$parent.$parent.visible = false;
                      _this3.$parent.$parent.getSuccess();
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              }));
              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }());
          }
        } else {
          return false;
        }
      });
    }),
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('resetForm');
    },
    uploadFile: function uploadFile(option) {
      var this_ = this;
      if (option.file) {
        var data = new FormData();
        data.append('file', option.file);
        data.append('bizType', 'MERCHANT_STORE');
        if (this_.ruleForm.id != null && this_.ruleForm.id != '') data.append('bizId', this_.ruleForm.id);else data.append('bizId', '');
        this.listLoading = true;
        abc.uploadObsApi(data).then(function (res) {
          this_.ruleForm.sliderImages.push(res.fileUrl);
        });
      }
    }
  }
};